import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { globalStore } from '../../../../shared/shared.global-service';
import { Injectable } from '@angular/core';
import { selectServices } from '../../../../../store/global/global.selectors';

@Injectable()
export class PersonEditBasicInfoStore extends ComponentStoreV2Factory {

    public services = globalStore.selectSignal(selectServices);
    public canEdit = this.isAllowed('person.update');

}
